import React, { useState } from 'react';
import { getProfileImageUrl } from '../helpers/getGravatarUrl';

const ProfileImage = ({ 
  src, 
  email, // Email for Gravatar fallback
  alt = "Profile", 
  className = "", 
  style = {},
  fallbackSrc = "/images/default_pic.png",
  showPlaceholder = true,
  placeholderText = "Image not available"
}) => {
  // Get profile image URL with Gravatar fallback
  const profileImageUrl = getProfileImageUrl(src, email, style.width || 200);
  const [imageState, setImageState] = useState('loading'); // 'loading', 'loaded', 'error'
  const [currentSrc, setCurrentSrc] = useState(profileImageUrl || fallbackSrc);

  const handleImageLoad = () => {
    setImageState('loaded');
  };

  const handleImageError = () => {
    if (currentSrc !== fallbackSrc) {
      // Try fallback image
      setCurrentSrc(fallbackSrc);
      setImageState('loading');
    } else {
      // Even fallback failed
      setImageState('error');
    }
  };

  const handleImageLoadStart = () => {
    setImageState('loading');
  };

  // Update src when prop changes
  React.useEffect(() => {
    const newImageUrl = getProfileImageUrl(src, email, style.width || 200);
    if (newImageUrl && newImageUrl !== currentSrc) {
      setCurrentSrc(newImageUrl);
      setImageState('loading');
    }
  }, [src, email, currentSrc, style.width]);

  if (imageState === 'error' && showPlaceholder) {
    return (
      <div 
        className={`image_placeholder ${className}`}
        style={{
          ...style,
          minHeight: style.height || '40px',
          minWidth: style.width || '40px'
        }}
      >
        {placeholderText}
      </div>
    );
  }

  return (
    <>
      <img
        src={currentSrc}
        alt={alt}
        className={`${className} ${imageState === 'loading' ? 'loading_image' : ''}`}
        style={{
          ...style,
          opacity: imageState === 'loaded' ? 1 : 0.7
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
        onLoadStart={handleImageLoadStart}
      />
    </>
  );
};

export default ProfileImage; 